<div class="fac__header">
  <admin-breadcrumbs></admin-breadcrumbs>

  <h3>Report Settings</h3>

  <div class="fac__tabs">
    <div class="fac__tabs-tab fac__tabs-tab--selected">
      Bed Board Setup
    </div>
  </div>
</div>

<div class="fac__body">

  <div class="fac__controls">
    
    <div class="fac__upload-wrapper">
      <input #fileInput class="fac__file-input" type="file" id="file-input"
        [attr.accept]="UPLOAD_CONFIG.acceptedTypes" (change)="onFileSelected($event)" />
      <button class="fac__upload-button btn btn-secondary btn-rounded btn-sm" for="file-input" (click)="fileInput.click()">
        <i class="fac__upload-icon fa fa-search"></i>Upload CSV File
      </button>

      <button class="fac__upload-button btn btn-secondary btn-rounded btn-sm" (click)="onDownloadCsv()">
        <i class="fac__upload-icon fa fa-download"></i>Download CSV File
      </button>
    </div>
    
  </div>

  <div class="fac__general-error">{{ generalError }}</div>

  <div *ngIf="!tableLoading; else loadingTpl" class="fac__table-container">

    <table class="fac__table">

      <thead>
        <tr class="fac__row">
          <th *ngFor="let column of columnConfigs" class="fac__th">
            {{ column.label }}
            <ng-container *ngIf="column.template === 'selectTpl' && unassignedByEhr[column.label]">({{ unassignedByEhr[column.label] }})</ng-container>
          </th>
          <th class="fac__th">
            Bed Status
          </th>
        </tr>
      </thead>
      <tbody>
      <tr *ngFor="let row of bedboardSettings; let index = index; trackBy: trackById" class="fac__row">
        <td *ngFor="let column of columnConfigs; trackBy: trackByKey" class="fac__td">
          {{ row[column.key] }}
        </td>
        <td>
          <form-field
            [config]="SELECT_CONFIG"
            [value]="row.bed_status"
            (onChange)="onSelectChange($event, row._id)">
          </form-field>
        </td>
      </tr>

      <tr *ngIf="!bedboardSettings?.length" class="fac__row">
        <td class="fac__td" colspan="14">
          No settings have been loaded yet.
        </td>
      </tr>
      </tbody>

    </table>

  </div>

</div>

<ng-template #loadingTpl>
  <div class="report__loading-state">
    <ngx-processing-anim [loader]="true"
      style="width: 17px; vertical-align: middle; padding-top: 5px; margin-left: 5px;"></ngx-processing-anim>
    Loading...
  </div>
</ng-template>

